import React from 'react'

const ExamContext = React.createContext({})
export const ExamProvider = ExamContext.Provider
export default ExamContext